import { PrimitiveType } from "@buildwithflux/models";
import { Clipper } from "../../clipper";
import { approxAABoundingBox, approxFittingPolygon, mergeApproxBoundingBoxes } from "./math";
import { chainCompoundPrimitiveTransforms } from "./math/utils";
function toSvgPolyline(primitive) {
    if (primitive.type === PrimitiveType.Union) {
        const [chainedA, chainedB] = chainCompoundPrimitiveTransforms(primitive);
        return toSvgPolyline(chainedA) + toSvgPolyline(chainedB);
    }
    if (primitive.type === PrimitiveType.Difference) {
        // TODO difference
        const [chainedA, _chainedB] = chainCompoundPrimitiveTransforms(primitive);
        return toSvgPolyline(chainedA);
    }
    const points = approxFittingPolygon(primitive, 128);
    return `<polyline points="${points.map((p) => [p.x, p.y].join(",")).join(" ")}" fill="red" />`;
}
// Limited, so useful only for debugging for now
export async function primitivesToSVG(primitives) {
    let svgString = ``;
    const boundingBox = mergeApproxBoundingBoxes(primitives.filter((p) => !!p).map((shape) => approxAABoundingBox(shape)));
    await Clipper.initialize();
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    primitives.forEach((shape) => {
        svgString += toSvgPolyline(shape);
    });
    const finalSvgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="1024" height="1024" viewBox="${boundingBox.minX} ${boundingBox.minY} ${boundingBox.maxX - boundingBox.minX} ${boundingBox.maxY - boundingBox.minY}">${svgString}</svg>`;
    return finalSvgString;
}
//# sourceMappingURL=primitivesToSVG.js.map